import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getDocsAssetsIndex } from '../../services';
import type { DocsAssetsIndex } from '../../services/docsAssets';

/**
 * Static file published at build time, so it never goes stale within a
 * session: fetched once, never refetched.
 */
export const useDocsAssetsIndex = (): UseQueryResult<
  DocsAssetsIndex,
  Error
> => {
  return useQuery({
    queryKey: ['get_docs_assets_index'],
    queryFn: getDocsAssetsIndex,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
